import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationEquipmentUpdatePutBody,
  IConfigurationEquipmentUpdateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationEquipmentUpdateAPI = () => {
  const [updatedEquipmentId, setUpdatedEquipmentId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (equipmentData: IConfigurationEquipmentUpdatePutBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .put(`${CONFIGURATION_APIS?.EQUIPMENT_UPDATE?.baseURL}`, equipmentData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationEquipmentUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedEquipmentId(res.data.data.equipment_id);
              toast.success(`${equipmentData?.equipment_name} has been updated.`);
            } else {
              toast.error("Error while fetchin equipments.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error;
          if (axiosError.response?.status === 400) {
            toast.error("Bad Request: " + axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          } else {
            toast.error("API Request failed: " + axiosError.message);
          }
        } else {
          toast.error("Unexpected error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { updatedEquipmentId, execute };
};
